import { useCallback } from 'react';
import { useCampaignEditorContext } from '../hooks/useCampaignEditorContext';
import { Template } from 'models/template/Template';
import { TargetAudienceType } from '../CampaignEditorState';

export const useSetTemplate = () => {
  const { dispatch } = useCampaignEditorContext();

  return useCallback(
    (audience: TargetAudienceType, template: Template) => {
      dispatch({ type: 'SET_TEMPLATE', payload: { [audience]: template } });
    },
    [dispatch],
  );
};
